import {AnalyticsEventMetadata} from 'analytics/AnalyticsTypes';
import {ActionOrigin} from 'constants/AnalyticsConstants';
import * as Context from 'Context';
import {StudyType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {logProfilerTimingEvent} from 'performance/BenchlingProfiler';
import {
  composeStudiesCreateStudyEventMetadata,
  STUDIES_CREATE_STUDY_ENDED_EVENT,
  STUDIES_CREATE_STUDY_STARTED_EVENT,
  ExecutionType,
} from 'performance/processStudiesEvents';
import {TypedStudyPerformanceMetadata} from 'studies/typed/utils/TypedStudyTypes';
import {withLoadingScreen} from 'util/Promises';

import {createStudies, CreateStudiesResponse, CreateStudyParams} from '../StudyDAO';

export async function onCreateStudy(
  creates: Array<CreateStudyParams>,
  actionOrigin: ActionOrigin,
  studyType: StudyType,
  analyticsMetadata: AnalyticsEventMetadata,
  typeSpecificPerformanceMetadata: TypedStudyPerformanceMetadata,
  callbacks: {
    onSuccess: () => void;
    onOpen: (response: CreateStudiesResponse) => void;
  }
): Promise<void> {
  await Context.usingAsync(
    {
      analyticsMetadata: {
        actionOrigin,
        studyType,
        studyTypeMetadata: analyticsMetadata,
      },
    },
    null,
    async () => {
      logProfilerTimingEvent(STUDIES_CREATE_STUDY_STARTED_EVENT);
      const response = await withLoadingScreen(createStudies(creates), 'Creating study...');
      callbacks.onSuccess();
      callbacks.onOpen(response);
      // Users can navigate away from the page before the study creation completes,
      // In which case we will miss this event. This is a best effort to log the event.
      logProfilerTimingEvent(
        STUDIES_CREATE_STUDY_ENDED_EVENT,
        composeStudiesCreateStudyEventMetadata(
          studyType,
          ExecutionType.SYNC,
          actionOrigin,
          typeSpecificPerformanceMetadata
        )
      );
    }
  );
}
